import { type IParentWidgetScope } from '../../../schema/widgets/IWidgetType.ts';

/**
 * Identifica se lo scope del parent è readonly.
 * Nello specifico, la definizione del readonly è gestita solo sul primo elemento
 * (root parent scope), definito al momento di creare il validatore
 *
 * @see [FormValidatorBuilder.createSectionsSchemaShape](../../form-builder/FormValidatorBuilder.ts)
 */
export function isParentWidgetScopeReadonly(
  parentScope: IParentWidgetScope,
): boolean {
  return parentScope?.[0]?.isReadonly ?? false;
}
